/** Light / dark / follow-the-computer theme, stored per browser and applied as `data-theme` on <html>. */

export type ThemeChoice = 'auto' | 'light' | 'dark';
const KEY = 'zp.theme';

/** The saved choice (default: follow the computer). */
export function getTheme(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'auto';
  } catch {
    return 'auto';
  }
}

/** Saves and applies a theme choice. */
export function setTheme(choice: ThemeChoice): void {
  try {
    if (choice === 'auto') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    // Storage blocked: applies for this visit only.
  }
  applyTheme(choice);
}

/** Puts the choice on <html> (the CSS reads `data-theme`). */
export function applyTheme(choice: ThemeChoice = getTheme()): void {
  const root = document.documentElement;
  if (choice === 'auto') delete root.dataset.theme;
  else root.dataset.theme = choice;
}
